<template>
    <div class="mt-12 flex flex-col lg:flex-row">
        <VerticalMenu :tabRefs="this.$refs" @updateUrlParams="updateUrlParams" :menuFixed="menuFixed" :items="subjects" />
        <div class="w-full lg:w-5/6" :ref="'subjects'" >
            <div :ref="subject.slug" :subjectKey="subject.key" :id="subject.slug" class="subjects" v-for="(subject, key) in this.subjectsTransformed">
                <div class="subjects__subject">

                    <div class="flex justify-between items-center mb-6">
                        <h2 class="text-2xl">{{ $__(subject.title) }}</h2>
                        <a v-if="key > 0" class="cursor-pointer item__header__plus flex" @click="scrollTop">
                            <download :class="'rotate-180 mr-2'"/>
                            {{ $__('kennisbank.go_up') }}
                        </a>
                    </div>

                    <item v-for="(post, key) in itemsTransformed[subject.id]"
                          @toggleItem="toggleItem"
                          @updateUrlParams="updateUrlParams"
                          @scrollIntoView="scrollIntoView"
                          :dataItemKey="key"
                          :dataSubjectKey="subject.id"
                          :post="post"
                          :subjectSlug="subject.slug"
                          :preselectedSubjectSlug="preselectedSubjectSlug"
                          :preselectedPostSlug="preselectedPostSlug"
                    />

                    <div v-if="key < this.subjectsTransformed.length - 1" class="w-full border-t-2 mt-6 mb-5 seperator"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VerticalMenu from "@/Components/VerticalMenu";
import Item from '@/Components/Kennisbank/Item';
import Download from '@/Components/Icons/Download';

export default {
    data: () => ({
        subjectsTransformed: [],
        menuFixed: false,
        itemsTransformed: {},
        subjectWasPreSelected: false,
    }),
    components: {
        Download,
        Item,
        VerticalMenu
    },
    props: {
        subjects: Object,
        items: Object,
        preselectedPostSlug: String,
        preselectedSubjectSlug: String,
    },
    methods: {
        setActiveSubject(subjectId) {
            this.$emit('setActiveSubject', subjectId)
        },
        handleScroll () {
            const refs = this.$refs;

            if(refs['subjects'].getBoundingClientRect().top < 49) {
                this.menuFixed = true;
            } else {
                this.menuFixed = false;
            }

            Object.keys(this.$refs).forEach((ref) => ref !== 'subjects' &&
                refs[ref] && refs[ref][0] && refs[ref][0].getBoundingClientRect().top < 25 ?
                    this.setActiveSubject(refs[ref][0].getAttribute('subjectKey')) : ''
            );
        },
        scrollIntoView(refKey, refs) {
            let ref = refs[refKey];

            if (typeof ref[0] !== "undefined") {
                ref = ref[0];
            }

            if (ref == null) {
                return;
            }

            ref.scrollIntoView();
        },
        scrollTop() {
            window.scrollTo(0,0);
        },
        updateUrlParams(subjectSlug = null, postSlug = null) {
            const currentUrl = new URL(window.location.href);

            if (subjectSlug != null) {
                currentUrl.searchParams.set('subject', subjectSlug);
            }

            if (postSlug != null) {
                currentUrl.searchParams.set('post', postSlug);
            }

            if (subjectSlug != null && postSlug == null) {
                currentUrl.searchParams.delete('post');
                this.scrollIntoView(subjectSlug, this.$refs)
            }

            history.pushState({}, null, currentUrl);
        },
        toggleItem(itemKey, subjectKey) {
            Object.keys(this.items).forEach(subject => {
                Object.keys(this.items[subject]).forEach(item => {
                    if (parseInt(itemKey) === parseInt(item) && parseInt(subjectKey) === parseInt(subject)) {
                        this.items[subject][item].open = !this.items[subject][item].open;
                        return;
                    }

                    this.items[subject][item].open = false;
                });
            });
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);

        Object.keys(this.$props.subjects).forEach((key) => {
            this.subjectsTransformed.push({
                ...this.$props.subjects[key],
                key: key
            });
        });

        this.itemsTransformed = this.items;
    },
    updated() {
        if (this.preselectedSubjectSlug == null || this.preselectedPostSlug != null ||
            this.subjectWasPreSelected !== false) {
            return;
        }

        this.subjectWasPreSelected = true;

        setTimeout(() => {
            this.scrollIntoView(this.preselectedSubjectSlug, this.$refs);
        }, 100)
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>
